import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// FIX: Real hero image URL as default so the hero renders instantly on first paint
// without waiting for the /settings API response
const DEFAULT_SETTINGS = {
  whatsapp_number: '+919780411102',
  social_links: { instagram: '', facebook: '', pinterest: '', youtube: '' },
  hero_banner_desktop: 'https://res.cloudinary.com/doaatitvq/image/upload/v1776230430/20260415_1048_Elegant_Necklace_Portrait_remix_01kp7s6jsbfpmbdaw8559dsz2t_dqelob.png',
  hero_banner_mobile: '',
  collection_images: {},
  instagram_images: [],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios.get(`${API}/settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const refresh = () => {
    axios.get(`${API}/settings`).then(r => setSettings(r.data)).catch(() => {});
  };

  const waLink = (msg = '') => {
    const num = settings.whatsapp_number?.replace(/[^0-9]/g, '') || '919780411102';
    return `https://wa.me/${num}${msg ? `?text=${encodeURIComponent(msg)}` : ''}`;
  };

  return (
    <SettingsContext.Provider value={{ settings, refresh, waLink }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used within SettingsProvider');
  return ctx;
}